<script>
import { VProgressCircular } from 'vuetify/lib'

export default {
  name: 'EStepperIndicator',
  extends: VProgressCircular,
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    steps: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 48,
    },
    rotate: {
      type: Number,
      default: -90,
    },
    width: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    classes() {
      return {
        'e-stepper-indicator': true,
      }
    },
    normalizedValue() {
      const calculatedValue = this.steps > 0 ? (this.value / this.steps) * 100 : 0
      if (calculatedValue < 0) {
        return 0
      }

      if (calculatedValue > 100) {
        return 100
      }

      return parseFloat(calculatedValue)
    },
  },
}
</script>
